import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { TYPES } from "../../constants/lessonPlans";
import { WEBSITE_DATA } from "../../constants/dashboard";
import BackArrow from "../../assets/backArrow.svg";
import VideoIcon from "../../assets/videoIcon.svg";
import PDFIcon from "../../assets/pdfIcon.svg";
import Timer from "../../assets/timer.svg";
import PDFThumbnail from "../../assets/pdf_thumbnail.svg";
import VideoThumbnail from "../../assets/video_thumbnail.svg";
import "./style.css";

const LessonPlanComponent = () => {
  const {
    state: { component, subject, chapter, day },
  } = useLocation();
  const navigate = useNavigate();

  console.log(window.location);

  const getMedia = (type, mediaURL, mediaName, time) => {
    return (
      <Link to={mediaURL} className="media">
        <div>
          <img
            src={type === TYPES.VIDEO ? VideoThumbnail : PDFThumbnail}
            alt="video"
            className="icon"
          />
        </div>

        <div className="text">
          <p>
            {mediaName.length > 23 ? mediaName.slice(0, 18) + "..." : mediaName}
          </p>
          <div className="cont">
            <img
              src={type === TYPES.VIDEO ? VideoIcon : PDFIcon}
              alt="video"
              className="icon"
            />
            <p id="text1">{type}</p>
            {type === TYPES.VIDEO && (
              <div className="timer">
                <img src={Timer} alt="timer" />
                <p id="text1">{time}</p>
              </div>
            )}
          </div>
        </div>
      </Link>
    );
  };

  const getDataList = (data) => {
    return data?.map((list, index) => {
      if (list.render) {
        return (
          <div
            key={index}
            dangerouslySetInnerHTML={{ __html: list.render }}
          ></div>
        );
      }
      if (list.type === TYPES.LEARNING_INDICATOR) {
        return (
          <div key={index}>
            <div>
              <strong>Learning Outcome</strong>
              {list?.text}
            </div>
            <ul>
              {list?.dataList?.map((dataList, index) => {
                return <li key={index}>{dataList.text}</li>;
              })}
            </ul>
          </div>
        );
      }

      if (list.type === TYPES.UNORDERED_LIST && list?.dataList) {
        return (
          <ul key={`list-${index + 1}`}>
            {list?.dataList?.map((dataList, index) => {
              if (dataList.type === TYPES.HEADING) {
                return (
                  <div className="title">
                    <strong>{dataList.text}</strong>
                  </div>
                );
              } else if (dataList.type === TYPES.PARAGRAPH) {
                return (
                  <div>
                    <div className="paragraph">{dataList.text}</div>
                    {dataList.media &&
                      getMedia(
                        dataList.mediaType,
                        dataList.media,
                        dataList.mediaName,
                        dataList.timeTakenToComplete
                      )}
                  </div>
                );
              } else {
                return dataList.text ? (
                  <li key={index}>
                    <div>{dataList.text}</div>
                    {dataList.media &&
                      getMedia(
                        dataList.mediaType,
                        dataList.media,
                        dataList.mediaName,
                        dataList.timeTakenToComplete
                      )}
                  </li>
                ) : (
                  <div key={index}>
                    {dataList.media &&
                      getMedia(
                        dataList.mediaType,
                        dataList.media,
                        dataList.mediaName,
                        dataList.timeTakenToComplete
                      )}
                  </div>
                );
              }
            })}
          </ul>
        );
      }

      if (list.type === TYPES.UNORDERED_LIST && list?.dataList) {
        return (
          <ul key={`list-${index + 1}`}>
            {list?.dataList?.map((dataList, index) => {
              return <li key={index}>{dataList.text}</li>;
            })}
          </ul>
        );
      }

      if (list.type === TYPES.ORDERED_LIST_ALPHA && list?.dataList) {
        return (
          <ol type="a" key={`list-${index + 1}`}>
            {list?.dataList?.map((dataList, index) => {
              return <li key={index}>{dataList.text}</li>;
            })}
          </ol>
        );
      }

      if (list.type === TYPES.ICON && list?.dataList) {
        return (
          <div key={`list-${index + 1}`}>
            {list?.dataList?.map((dataList, index) => {
              return (
                <div key={index}>
                  <img src="" alt="check-icon" />
                  <>{dataList.text}</>
                </div>
              );
            })}
          </div>
        );
      }

      return (
        <div className="list-flex">
          {list?.icon && <img src={list?.icon} alt="icon" />}
          <div>{list.text}</div>
        </div>
      );
    });
  };

  return (
    <>
      <div className="head">
        <img
          src={BackArrow}
          className="back"
          alt="back"
          onClick={() => navigate("/tas")}
        />
        <img id="img" src={WEBSITE_DATA?.logo} alt="title" />
      </div>
      <div className="tab-container">
        <div className="top">
          <p className="letters">
            {subject} {"  >  "} {chapter} - Day {day}
          </p>
        </div>
        <div className="lp-container">
          {component.map((lp, index) => {
            return (
              <section className="lp-section" key={`lp-${index + 1}`}>
                <div className="lp-section-header">
                  {lp.icon && (
                    <img
                      src={lp.icon}
                      alt="section-icon"
                      className="section-icon"
                    />
                  )}
                  <div>
                    <h2 className="heading">{lp.heading}</h2>
                    <p className="subhead">{lp.subHeading}</p>

                    {lp.timeTakenToComplete && (
                      <div className="section-time">
                        <img src={Timer} alt="timer" className="clock-icon" />
                        <p>{lp.timeTakenToComplete}</p>
                      </div>
                    )}
                  </div>
                </div>
                {<div>{lp.text}</div>}
                {!!lp.dataList.length && getDataList(lp.dataList)}
                {!!lp.render && (
                  <div dangerouslySetInnerHTML={{ __html: lp.render }}></div>
                )}
                {!!lp.media &&
                  getMedia(
                    lp.mediaType,
                    lp.media,
                    lp.mediaName,
                    lp.timeTakenToComplete
                  )}
              </section>
            );
          })}
        </div>
        <div className="footer">
          <div className="line"></div>
        </div>
      </div>
    </>
  );
};

export default LessonPlanComponent;
